import {
    Row,
    Col,
    Label,
    DropdownBox,
    InputField,
    PrimaryButton,
    ModalPopup,
    OutlineButton,
    SofturaTable,
    SwitchToggle,
    ReactSelectBox,
    Tooltip,
    EventHandler,
    PopupDialogbox,
} from "client/CommonComponents";
import "./PurchaseDetail.scss";
import AssetPoolPopup from "./AssetPoolPopup";
import refresh from "../../../../assets/images/Reset.svg";
import CancelConfirmationPopup from "../CancelConfirmationpopup";
import { useMemo, useState, useEffect, useRef } from "react";
import { getBudgetingPriceDisplay } from "utils";
import { CONSTANTS } from "client/utils/constants";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
// Reuse order-creation sub-type presentation components directly (not their Containers)
import MowerPresentation from "client/Components/OrderManagement/Requisition/RequisitionType/ManagedEquipment/Mower/Mower";
import SnowPresentation from "client/Components/OrderManagement/Requisition/RequisitionType/ManagedEquipment/Snow/Snow";
import TrailerPresentation from "client/Components/OrderManagement/Requisition/RequisitionType/ManagedEquipment/Trailer/Trailer";
import DevelopmentPresentation from "client/Components/OrderManagement/Requisition/RequisitionType/ManagedEquipment/Development/Development";
import StandardizedEquipmentPresentation from "client/Components/OrderManagement/Requisition/RequisitionType/ManagedEquipment/StandarizedEquipment/StandarizedEquipment";
import UtilityVehiclePresentation from "client/Components/OrderManagement/Requisition/RequisitionType/ManagedEquipment/UtilityVehicle/UtilityVehicle";

interface IProps {
    showPoolPopup?: boolean;
    togglePopup: Function;
    purchaseType?: any;
    registeredType?: any;
    orderType?: any;
    reasonCode?: any;
    poolGridData?: any;
    handleClickPick?: any;
    activeRow?: any;
    handleClickRestore?: any;
    handleClickCancel?: any;
    Popupcontent?: any;
    hideDialog?: any;
    popupOutlinebtnOnclick?: any;
    popupPrimarybtnOnclick?: any;
    onChangeAsset?: any;
    handleChange?: any;
    handleChangeDropDown?: any;
    purchaseOrderStepperData?: any;
    errors?: any;
    skipVendorDetail: boolean;
    savePurchaseOrder?: Function;
    assetPoolError?: string;
    setAssetPoolError?: Function;
    isCompleted?: boolean;
    isVehicleConsolidatedChecked?: string;
    isManageEquipConsolidatedChecked?: string;
    isNonstandardConsolidatedChecked?: string;
    itemDetails?: any;
    handleBlurChange?:any;
    unitPriceFormat?:any
    check?: any,
    onChangeDescription?: any,
    getDescriptionDropdown?: any,
    onClick?: any
    isBulkOrderRequest?: boolean;
    isRequisitionComplete?: boolean;
    isLicensedTitled: boolean;
    getUserRoles?: any;
    vinValidationResult?: any;
    originalVinSerial?: string;
    isCatalogOverrideEnabled?: boolean;
    onCatalogOverrideToggleChange?: (event: any, isEnabled?: boolean) => void;
    catalogOverridePopupcontent?: any;
    hideCatalogOverrideDialog?: any;
    showCatalogOverrideSection?: boolean;
    onSelectCatalogItem?: (assetModelId: any) => void;
    catalogItemByAssetModelId?: any;
    showCatalogComparePopup?: boolean;
    setShowCatalogComparePopup?: (val: boolean) => void;
    originalBudgetingPrice?: number;
    newBudgetingPrice?: number;
    isPriceThresholdViolation?: boolean;
    SearchedCatalog?: any
    isCatalogSearchDisabled?: boolean;
    isSearched?: any
    orderDetails?: any;
    catalogOverrideDropDownValues?: any;
    catalogOverrideCriteria?: any;
    onCatalogOverrideDropdownChange?: (fieldName: string, val: any) => void;
    onCatalogOverrideEquipmentTypeChange?: (val: any) => void;
    // Matches the (e, item, name) signature used by all order-creation sub-container handlers
    onManagedEquipSubFieldChange?: (e: any, item: any, name: string) => void;
    // Catalog search results bound from API response
    catalogGridData?: any[];
    onSaveCatalogOverride?: () => void;
}
const PurchaseDetail = ({
    popupPrimarybtnOnclick,
    Popupcontent,
    hideDialog,
    popupOutlinebtnOnclick,
    handleClickCancel,
    handleClickRestore,
    activeRow,
    handleClickPick,
    poolGridData,
    showPoolPopup,
    togglePopup,
    purchaseType,
    registeredType,
    orderType,
    reasonCode,
    handleChange,
    handleChangeDropDown,
    purchaseOrderStepperData,
    errors,
    savePurchaseOrder,
    setAssetPoolError,
    assetPoolError,
    isCompleted,
    isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked,
    isNonstandardConsolidatedChecked,
    itemDetails,
    handleBlurChange,
    unitPriceFormat,
    check,
    onChangeDescription,
    getDescriptionDropdown,
    onClick,
    isBulkOrderRequest,
    isRequisitionComplete,
    isLicensedTitled,
    getUserRoles,
    originalVinSerial,
    vinValidationResult,
    isCatalogOverrideEnabled,
    onCatalogOverrideToggleChange,
    catalogOverridePopupcontent,
    hideCatalogOverrideDialog,
    showCatalogOverrideSection,
    onSelectCatalogItem,
    catalogItemByAssetModelId,
    showCatalogComparePopup,
    setShowCatalogComparePopup,
    originalBudgetingPrice,
    newBudgetingPrice,
    isPriceThresholdViolation,
    SearchedCatalog,
    isCatalogSearchDisabled,
    isSearched,
    orderDetails,
    catalogOverrideDropDownValues,
    catalogOverrideCriteria,
    onCatalogOverrideDropdownChange,
    onCatalogOverrideEquipmentTypeChange,
    onManagedEquipSubFieldChange,
    catalogGridData = [],
    onSaveCatalogOverride,
}: IProps) => {
    const [showCatalogGrid, setShowCatalogGrid] = useState<boolean>(false);

    const originalBudgetingPriceValue = originalBudgetingPrice ?? 0;
    const newBudgetingPriceValue = newBudgetingPrice ?? 0;
    const isPriceThresholdViolationValue = !!isPriceThresholdViolation;
    const isZeroOrInvalidCatalogPrice = !Number.isFinite(newBudgetingPriceValue) || newBudgetingPriceValue <= 0;
    const isCompareSaveDisabled = isPriceThresholdViolationValue || isZeroOrInvalidCatalogPrice;

    useEffect(() => {
        if (!showCatalogOverrideSection) {
            setShowCatalogGrid(false);
        }
    }, [showCatalogOverrideSection]);

    useEffect(() => {
        if (isCatalogOverrideEnabled) {
            const timer = setTimeout(() => {
                const commentField = document.getElementById(
                    "purchase-detail-catalog-override-comment"
                );

                if (commentField) {
                    commentField.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [isCatalogOverrideEnabled]);

    const currentItemNumber = useMemo(
        () => Number(String(itemDetails?.itemId ?? "").split("-")[1]),
        [itemDetails?.itemId]
    );
    const currentRequest = useMemo(() => {
        const requests = orderDetails?.requests ?? [];
        const requestId = purchaseOrderStepperData?.requestId ?? itemDetails?.requestId;

        return (
            requests.find((request: any) => Number(request?.requestId) === Number(requestId)) ??
            requests.find((request: any) => Number(request?.itemNumber) === currentItemNumber) ??
            null
        );
    }, [currentItemNumber, itemDetails?.requestId, orderDetails?.requests, purchaseOrderStepperData?.requestId]);

    // Resolve subtype from the current item's matching request, never from the first request in the order.
    const effectiveSubType = useMemo(() => {
        const subTypeFromItem = itemDetails?.orderRequestSubType;
        if (subTypeFromItem === CONSTANTS.PRODUCTION_VEHICLE || subTypeFromItem === CONSTANTS.MANAGEMENT_VEHICLE) {
            return subTypeFromItem;
        }
        if (
            currentRequest?.subOrderType === CONSTANTS.PRODUCTION_VEHICLE ||
            currentRequest?.subOrderType === CONSTANTS.MANAGEMENT_VEHICLE
        ) {
            return currentRequest?.subOrderType;
        }
        return subTypeFromItem;
    }, [currentRequest?.subOrderType, itemDetails?.orderRequestSubType]);

    const isProductionVehicle = effectiveSubType === CONSTANTS.PRODUCTION_VEHICLE;
    const isManagementVehicle = effectiveSubType === CONSTANTS.MANAGEMENT_VEHICLE;
    const isManagedEquipment =
        itemDetails?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT;
    const isCatalogOverrideEligible =
        isProductionVehicle || isManagementVehicle || isManagedEquipment;

    // Dummy ref passed to ME presentation components — focus management is not needed in fleet context
    const meSubFieldRef = useRef<any>([]);

    const catalogGridColumns = useMemo(() => [
        {
            key: "select",
            title: "",
            width: "100px",
            Cell: (row: any) => (
                <OutlineButton
                    text="Select"
                    className="catalog-grid-select-btn"
                    onClick={() => {
                        onSelectCatalogItem && onSelectCatalogItem(row?.rowData?.assetModelId);
                    }}
                />
            ),
        },
        { key: "catalogItemId", title: "Catalog Item#", width: "140px" },
        { key: "description", title: "Description", width: "420px" },
        { key: "eOneDescription", title: "EOne Description", width: "260px" },
        {
            key: "eqClassCodeDesc",
            title: "Eq Class Code/Desc",
            width: "320px",
            Cell: (row: any) => {
                const rowData = row?.rowData ?? row;
                const code = rowData?.eqClassCode ?? "";
                const description = rowData?.eqClassDesc ?? "";

                if (!code && !description) {
                    return "";
                }

                if (!code) {
                    return description;
                }

                if (!description) {
                    return code;
                }

                return `${code} - ${description}`;
            },
        },
    ], [onSelectCatalogItem]);

    const purchaseTypeValue = useMemo(() => {
        return purchaseType?.find(
            (x: any) => x.value === purchaseOrderStepperData?.purchaseType
        );
    }, [purchaseOrderStepperData?.purchaseType, purchaseType]);

    const orderTypeValue = useMemo(() => {
        return orderType?.find(
            (x: any) => x.text === (purchaseOrderStepperData?.orderType ?? "N/A")
        );
    }, [purchaseOrderStepperData?.orderType, orderType]);

    const isBulkOrder = useMemo(() => {
        return purchaseOrderStepperData?.assetSourcing === "CIP/Bulk Order";
    }, [purchaseOrderStepperData?.assetSourcing]);

    return (
        <>
            <Row className="border purchase-tooltip px-0 mx-0">
                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <Label data-attribute="PurchaseDetail_Default_Label_16">Purchase Type</Label>
                    <DropdownBox
                        name="purchaseType"
                        selectedKey={purchaseTypeValue?.key}
                        placeholder="Select"
                        onChange={handleChangeDropDown}
                        options={purchaseType}
                        disabled={purchaseOrderStepperData.poNumber || check || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                        data-attribute="PurchaseDetail_purchaseType_Dropdown" />
                </Col>
                {!isBulkOrder && (
                    <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                        <Label required data-attribute="PurchaseDetail_Default_Label_2_2">Price Per unit $</Label>
                        <InputField
                            name="pricePerUnit"
                            onBlur={(event: any) => unitPriceFormat(event.target.value)}
                            value={purchaseOrderStepperData?.pricePerUnit}
                            onChange={handleChange}
                            prefix="$"
                            className="pricePerUnit"
                            disabled={purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || check || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                            data-attribute="PurchaseDetail_pricePerUnit_Input" />
                        {errors?.pricePerUnit && (
                            <span className="validMessage">
                                {purchaseOrderStepperData?.pricePerUnit?.length > 15 ? "Please enter Price Per unit less than 15 Digits" : "Please enter Price Per unit"}
                            </span>
                        )}
                    </Col>
                )}
                {isBulkOrder && (
                    <>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_3_2">Unit #</Label>
                            <InputField
                                name="cipUnitNumber"
                                value={purchaseOrderStepperData?.pocipDetails?.cipUnitNumber}
                                disabled
                                data-attribute="PurchaseDetail_cipUnitNumber_Input" />
                        </Col>
                    </>
                )}
                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <Label required data-attribute="PurchaseDetail_Default_Label_4_2">Asset #</Label>
                    <div className="assetNumber">
                        <InputField
                            name="assetNumber"
                            placeholder="Enter Asset Number"
                            className={(errors?.assetNumber ? "controlValidation me-2" : "me-2")}
                            value={purchaseOrderStepperData.assetNumber}
                            onChange={handleChange}
                            autoComplete="off"
                            disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || isRequisitionComplete || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                            onBlur={handleBlurChange}
                            data-attribute="PurchaseDetail_assetNumber_Input" />
                        {
                            (purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || isRequisitionComplete || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)) ?
                                null
                                : <EventHandler onEvent={handleClickRestore} data-attribute="PurchaseDetail_Default_EventHandler">
                                    <img
                                        src={refresh}
                                        alt="reset"
                                        title="Reset"
                                        className={`refresh-asset fa-pencil ${isBulkOrderRequest ? 'bulkorderrefresh' : ''}`}
                                    />
                                </EventHandler>
                        }
                        {!isBulkOrderRequest && <PrimaryButton
                            text="Pool"
                            className="poolBtn"
                            onClick={togglePopup}
                            disabled={ isVehicleConsolidatedChecked == itemDetails?.orderRequestType || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||  isManageEquipConsolidatedChecked == itemDetails?.orderRequestType ||  isNonstandardConsolidatedChecked == itemDetails?.orderRequestType || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || isRequisitionComplete  || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                            data-attribute="PurchaseDetail_Default_Button" />}
                    </div>
                    {purchaseOrderStepperData?.validationMessage && (
                        <span className="validMessage">
                            {purchaseOrderStepperData?.validationMessage}
                        </span>
                    )}
                </Col>
                {isBulkOrder && (
                    <>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_5_2">Description</Label>
                            <InputField
                                name="cipDesc"
                                value={purchaseOrderStepperData?.pocipDetails?.cipDesc}
                                disabled
                                data-attribute="PurchaseDetail_cipDesc_Input" />
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_6_2">Model Year</Label>
                            <InputField
                                name="cipModelYear"
                                value={purchaseOrderStepperData?.pocipDetails?.cipModelYear}
                                disabled
                                data-attribute="PurchaseDetail_cipModelYear_Input" />
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_7_2">Manuf. Code</Label>
                            <InputField
                                name="cipManufac"
                                value={purchaseOrderStepperData?.pocipDetails?.cipManufac}
                                disabled
                                data-attribute="PurchaseDetail_cipManufac_Input" />
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_8_2">Serial/VIN</Label>
                            <InputField
                                name="cipSerialNumber"
                                value={purchaseOrderStepperData?.pocipDetails?.cipSerialNumber}
                                disabled
                                data-attribute="PurchaseDetail_cipSerialNumber_Input" />
                            {purchaseOrderStepperData?.vinSerialMismatch && (
                                <span className="validMessage">
                                    VIN/Serial# is different than the VIN/Serial# from E1/CIP Pool
                                </span>
                            )}
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_9_2">GVWR</Label>
                            <InputField
                                name="cipgvw"
                                value={purchaseOrderStepperData?.pocipDetails?.cipgvw}
                                disabled
                                data-attribute="PurchaseDetail_cipgvw_Input" />
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_10_2">Eq. Class Code</Label>
                            <InputField
                                name="cipEqClass"
                                value={purchaseOrderStepperData?.pocipDetails?.cipEqClass}
                                disabled
                                data-attribute="PurchaseDetail_cipEqClass_Input" />
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                            <Label data-attribute="PurchaseDetail_Default_Label_11_2">CIP PO #</Label>
                            <InputField
                                name="cippoNumber"
                                value={purchaseOrderStepperData?.pocipDetails?.cippoNumber}
                                disabled
                                data-attribute="PurchaseDetail_cippoNumber_Input" />
                        </Col>
                    </>
                )}

                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <Label data-attribute="PurchaseDetail_Default_Label_12_2">Order Type</Label>
                    <DropdownBox
                        name="orderTypeId"
                        selectedKey={orderTypeValue?.key}
                        onChange={handleChangeDropDown}
                        placeholder="Select"
                        options={orderType}
                        disabled={purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || check || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                        data-attribute="PurchaseDetail_orderTypeId_Dropdown" />
                </Col>
                {
                    itemDetails.orderRequestType !== CONSTANTS.NON_STANDARD_EQUIPMENT &&
                    !isBulkOrder && <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                        <Label required data-attribute="PurchaseDetail_Default_Label_13_2">Description</Label>
                        <EventHandler onEvent={onClick} data-attribute="PurchaseDetail_Default_EventHandler_2">
                            <div>
                                <Tooltip content={purchaseOrderStepperData?.descriptionId?.label || ''} data-attribute="PurchaseDetail_Default_Tooltip_17">
                                    <ReactSelectBox
                                        name="descriptionId"
                                        value={purchaseOrderStepperData?.descriptionId?.value ? purchaseOrderStepperData?.descriptionId : ""}
                      onChange={(item:any)=>onChangeDescription(item)}
                                        placeholder="Select Description"
                                        isSearchable={true}
                                        options={purchaseOrderStepperData?.catalogSpecification ?? []}
                                        isDisabled={purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || check || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                                        data-attribute="PurchaseDetail_descriptionId_SearchSelectBox" />
                                </Tooltip>
                                {errors?.descriptionError && (
                                    <span className="validMessage">
                                        {errors?.descriptionError}
                                    </span>
                                )}
                            </div>
                        </EventHandler>
                    </Col>
                }

                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <Label data-attribute="PurchaseDetail_Default_Label_14_2">Asset Sourcing</Label>
                    <InputField
                        name="assetSourcing"
                        value={purchaseOrderStepperData.assetSourcing}
                        onChange={handleChange}
                        placeholder="Stock"
                        disabled
                        data-attribute="PurchaseDetail_assetSourcing_Input" />
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
                    <Label data-attribute="PurchaseDetail_Default_Label_15_2">
                        Vin/Serial #
                        {purchaseOrderStepperData?.vinSerialSource && (
                            <span className="vin-source-label">
                                (Source: {purchaseOrderStepperData.vinSerialSource})
                            </span>
                        )}
                    </Label>
                    <InputField
                        name="vinSerial"
                        placeholder="Enter Vin/Serial Number"
                        value={purchaseOrderStepperData.vinSerial || ""}
                        onChange={handleChange}
                        autoComplete="off"

                        disabled={
                            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED ||
                            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                            purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE ||
                            isRequisitionComplete ||
                            !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS) ||
                            // Disable if original saved VIN exists AND asset receiving task is completed (unless SuperAdmin)
                            (originalVinSerial && purchaseOrderStepperData?.isReceivedAssetCompleted && !getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN))
                        }
                        data-attribute="PurchaseDetail_vinSerial_Input" />
                    {errors?.vinSerial && (
                        <span className="validMessage">
                            {errors?.vinSerial}
                        </span>
                    )}
                </Col>

        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="purchase-detail-switchtoggle">
            <SwitchToggle
              name="isLicensedTitled"
              onChange={handleChange}
              checked={isLicensedTitled}
              label='Is this Asset to be Licensed or Titled ?'
              disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || isRequisitionComplete || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)} data-attribute="PurchaseDetail_Is_this_Asset_to_be_Licensed_or_Titled_SwitchToggle" />
            {isCatalogOverrideEligible && (
              <SwitchToggle
                name="isCatalogOverride"
                onChange={onCatalogOverrideToggleChange}
                checked={isCatalogOverrideEnabled}
                label="Catalog Override?"
                disabled={
                  !!purchaseOrderStepperData?.poNumber ||
                  purchaseOrderStepperData?.assetSourcing === "CIP/Bulk Order" ||
                  purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED ||
                  purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ||
                  isRequisitionComplete ||
                  purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE ||
                  !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)
                }
                data-attribute="PurchaseDetail_CatalogOverride_SwitchToggle"
              />
            )}
          </div>
        </Col>
        {showCatalogOverrideSection && isCatalogOverrideEligible && (
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="mt-3">
            <div className="vehicle-request-summary-bar">
              {isManagedEquipment ? (
                // For Managed Equipment, show the original equipment type selection
                <div className="vehicle-request-summary-item">
                  <span className="summary-label">Equipment Type</span>
                  <span className="summary-value">{itemDetails?.orderRequestSubType ?? '-'}</span>
                </div>
              ) : (
                // For Production Vehicle and Management Vehicle, show the original criteria
                <>
                  {isManagementVehicle && <div className="vehicle-request-summary-item"><span className="summary-label">Driver Title</span><span className="summary-value">{itemDetails?.driverTitle ?? '-'}</span></div>}
                  <div className="vehicle-request-summary-item"><span className="summary-label">Vehicle</span><span className="summary-value">{itemDetails?.vechileType ?? '-'}</span></div>
                  {itemDetails?.showVehicleCapacity && <div className="vehicle-request-summary-item"><span className="summary-label">Vehicle Capacity</span><span className="summary-value">{itemDetails?.vehicleCapacity ?? '-'}</span></div>}
                  {isProductionVehicle && <div className="vehicle-request-summary-item"><span className="summary-label">Upfit Option</span><span className="summary-value">{itemDetails?.upfitOption ?? '-'}</span></div>}
                  {isProductionVehicle && <div className="vehicle-request-summary-item"><span className="summary-label">Snow Setup</span><span className="summary-value">{itemDetails?.snowSetup ?? '-'}</span></div>}
                  {isProductionVehicle && <div className="vehicle-request-summary-item"><span className="summary-label"># of Doors</span><span className="summary-value">{itemDetails?.noOfDoors ?? '-'}</span></div>}
                  <div className="vehicle-request-summary-item"><span className="summary-label">Drive Train</span><span className="summary-value">{itemDetails?.driveTrain ?? '-'}</span></div>
                  <div className="vehicle-request-summary-item"><span className="summary-label">Fuel Type</span><span className="summary-value">{itemDetails?.fuelType ?? '-'}</span></div>
                </>
              )}
            </div>
            <div className="vehicle-request-form">
              {isProductionVehicle && (
                <>
                  {/* Upfit Option — always shown, loaded on section open */}
                  <div className="vehicle-request-form-row">
                    <div className="vehicle-request-form-col">
                      <Label required>Upfit Option</Label>
                      <ReactSelectBox
                        options={catalogOverrideDropDownValues?.upfitOptionList ?? []}
                        onChange={(val: any) => onCatalogOverrideDropdownChange?.('upfitOption', val)}
                        value={catalogOverrideCriteria?.upfitOption}
                        placeholder="Select"
                      />
                    </div>
                    {/* Snow Setup — appears after Upfit Option is loaded */}
                    {catalogOverrideDropDownValues?.snowSetupList?.length > 0 && (
                      <div className="vehicle-request-form-col">
                        <Label required>Snow Setup</Label>
                        <ReactSelectBox
                          options={catalogOverrideDropDownValues.snowSetupList}
                          onChange={(val: any) => onCatalogOverrideDropdownChange?.('snowSetup', val)}
                          value={catalogOverrideCriteria?.snowSetup}
                          placeholder="Select"
                        />
                      </div>
                    )}
                    {/* Vehicle — appears after Snow Setup is selected */}
                    {catalogOverrideDropDownValues?.vehicleList?.length > 0 && (
                      <div className="vehicle-request-form-col">
                        <Label required>Vehicle</Label>
                        <ReactSelectBox
                          options={catalogOverrideDropDownValues.vehicleList}
                          onChange={(val: any) => onCatalogOverrideDropdownChange?.('vehicle', val)}
                          value={catalogOverrideCriteria?.vehicle}
                          placeholder="Select"
                        />
                      </div>
                    )}
                  </div>
                  {/* Row 2: Vehicle Capacity (conditional) | # of Doors | Drive Train — all in same row */}
                  {(catalogOverrideDropDownValues?.vehicleCapacityList?.length > 0 ||
                    catalogOverrideDropDownValues?.noOfDoorsList?.length > 0 ||
                    catalogOverrideDropDownValues?.driveTrainList?.length > 0) && (
                    <div className="vehicle-request-form-row">
                      {catalogOverrideDropDownValues?.vehicleCapacityList?.length > 0 && (
                        <div className="vehicle-request-form-col">
                          <Label required>Vehicle Capacity</Label>
                          <ReactSelectBox
                            options={catalogOverrideDropDownValues.vehicleCapacityList}
                            onChange={(val: any) => onCatalogOverrideDropdownChange?.('vehicleCapacity', val)}
                            value={catalogOverrideCriteria?.vehicleCapacity}
                            placeholder="Select"
                          />
                        </div>
                      )}
                      {catalogOverrideDropDownValues?.noOfDoorsList?.length > 0 && (
                        <div className="vehicle-request-form-col">
                          <Label required># of Doors</Label>
                          <ReactSelectBox
                            options={catalogOverrideDropDownValues.noOfDoorsList}
                            onChange={(val: any) => onCatalogOverrideDropdownChange?.('noOfDoors', val)}
                            value={catalogOverrideCriteria?.noOfDoors}
                            placeholder="Select"
                          />
                        </div>
                      )}
                      {catalogOverrideDropDownValues?.driveTrainList?.length > 0 && (
                        <div className="vehicle-request-form-col">
                          <Label required>Drive Train</Label>
                          <ReactSelectBox
                            options={catalogOverrideDropDownValues.driveTrainList}
                            onChange={(val: any) => onCatalogOverrideDropdownChange?.('driveTrain', val)}
                            value={catalogOverrideCriteria?.driveTrain}
                            placeholder="Select"
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {/* Row 3: Fuel Type (optional) | Search */}
                  <div className="vehicle-request-form-row">
                    {catalogOverrideDropDownValues?.fuelTypeList?.length > 0 && (
                      <div className="vehicle-request-form-col">
                        <Label>Fuel Type</Label>
                        <ReactSelectBox
                          options={catalogOverrideDropDownValues.fuelTypeList}
                          onChange={(val: any) => onCatalogOverrideDropdownChange?.('fuelType', val)}
                          value={catalogOverrideCriteria?.fuelType}
                          placeholder="Select"
                        />
                      </div>
                    )}
                    <div className="vehicle-request-form-col col-end-btn">
                      <PrimaryButton
                        text="Search"
                        disabled={isCatalogSearchDisabled}
                        onClick={() => { SearchedCatalog?.(); setShowCatalogGrid(true); }}
                      />
                    </div>
                  </div>
                </>
              )}

                                {isManagementVehicle && (
                                    <>
                                        {/* Driver Title — always shown, loaded on section open */}
                                        <div className="vehicle-request-form-row">
                                            <div className="vehicle-request-form-col">
                                                <Label required>Driver Title</Label>
                                                <ReactSelectBox
                                                    options={catalogOverrideDropDownValues?.driverTitleList ?? []}
                                                    onChange={(val: any) => onCatalogOverrideDropdownChange?.('driverTitle', val)}
                                                    value={catalogOverrideCriteria?.driverTitle}
                                                    placeholder="Select"
                                                />
                                            </div>
                                            {/* Vehicle — appears after Driver Title is selected */}
                                            {catalogOverrideDropDownValues?.vehicleList?.length > 0 && (
                                                <div className="vehicle-request-form-col">
                                                    <Label required>Vehicle</Label>
                                                    <ReactSelectBox
                                                        options={catalogOverrideDropDownValues.vehicleList}
                                                        onChange={(val: any) => onCatalogOverrideDropdownChange?.('vehicle', val)}
                                                        value={catalogOverrideCriteria?.vehicle}
                                                        placeholder="Select"
                                                    />
                                                </div>
                                            )}
                                            {/* Drive Train — appears after Vehicle is selected */}
                                            {catalogOverrideDropDownValues?.driveTrainList?.length > 0 && (
                                                <div className="vehicle-request-form-col">
                                                    <Label required>Drive Train</Label>
                                                    <ReactSelectBox
                                                        options={catalogOverrideDropDownValues.driveTrainList}
                                                        onChange={(val: any) => onCatalogOverrideDropdownChange?.('driveTrain', val)}
                                                        value={catalogOverrideCriteria?.driveTrain}
                                                        placeholder="Select"
                                                    />
                                                </div>
                                            )}
                                            {/* Fuel Type — optional, appears after Drive Train */}
                                            {catalogOverrideDropDownValues?.fuelTypeList?.length > 0 && (
                                                <div className="vehicle-request-form-col">
                                                    <Label>Fuel Type</Label>
                                                    <ReactSelectBox
                                                        options={catalogOverrideDropDownValues.fuelTypeList}
                                                        onChange={(val: any) => onCatalogOverrideDropdownChange?.('fuelType', val)}
                                                        value={catalogOverrideCriteria?.fuelType}
                                                        placeholder="Select"
                                                    />
                                                </div>
                                            )}
                                            <div className="vehicle-request-form-col col-end-btn">
                                                <PrimaryButton
                                                    text="Search"
                                                    disabled={isCatalogSearchDisabled}
                                                    onClick={() => { SearchedCatalog?.(); setShowCatalogGrid(true); }}
                                                />
                                            </div>
                                        </div>

                                    </>
                                )}

                                {isManagedEquipment && (
                                    <>
                                        {/* Equipment Type + sub-type fields in a single Bootstrap Row, 3 cols per row — matches creation flow */}
                                        <Row className="mb-2">
                                            <Col xs={12} sm={4} md={4} lg={4} className="mb-3">
                                                <Label required>Equipment Type</Label>
                                                <ReactSelectBox
                                                    options={catalogOverrideDropDownValues?.equipmentTypeList ?? []}
                                                    onChange={(val: any) => onCatalogOverrideEquipmentTypeChange?.(val)}
                                                    value={catalogOverrideCriteria?.equipmentType}
                                                    placeholder="Select"
                                                />
                                            </Col>

                                            {/* Mower — 8 fields: stateAvailability, manufacturer, programStatus, annualHours, category, deckSize, deckType, autonomous */}
                                            {catalogOverrideCriteria?.equipmentType?.label === CONSTANTS.MOWER && (
                                                <MowerPresentation
                                                    managedEquipmentValues={catalogOverrideCriteria?.managedEquipFields}
                                                    managedMowerRef={meSubFieldRef}
                                                    stateAvailabilityDropDownList={catalogOverrideDropDownValues?.stateAvailability ?? []}
                                                    manufacturerDropDownList={catalogOverrideDropDownValues?.manufacturer ?? []}
                                                    programStatusDropDownList={catalogOverrideDropDownValues?.programStatus ?? []}
                                                    annualHoursDropDownList={catalogOverrideDropDownValues?.annualHours ?? []}
                                                    categoryDropdownList={catalogOverrideDropDownValues?.category ?? []}
                                                    deckSizeDropDownList={catalogOverrideDropDownValues?.deckSize ?? []}
                                                    deckTypeDropDownList={catalogOverrideDropDownValues?.deckType ?? []}
                                                    autonomousDropDownList={catalogOverrideDropDownValues?.autonomous ?? []}
                                                    handleAvailabilityChanges={onManagedEquipSubFieldChange}
                                                    handleManufacturerChanges={onManagedEquipSubFieldChange}
                                                    handleProgramStatusChanges={onManagedEquipSubFieldChange}
                                                    handleAnnualHoursChanges={onManagedEquipSubFieldChange}
                                                    handleCategeoryChanges={onManagedEquipSubFieldChange}
                                                    handleDeckSizeChanges={onManagedEquipSubFieldChange}
                                                    handleDeckTypeChanges={onManagedEquipSubFieldChange}
                                                    handleAutonomousChanges={onManagedEquipSubFieldChange}
                                                />
                                            )}

                                            {/* Snow — 4 fields: manufacturer, category, size, type */}
                                            {catalogOverrideCriteria?.equipmentType?.label === CONSTANTS.SNOW && (
                                                <SnowPresentation
                                                    managedEquipmentValues={catalogOverrideCriteria?.managedEquipFields}
                                                    managedEquipRef={meSubFieldRef}
                                                    manufacturerDropDownList={catalogOverrideDropDownValues?.manufacturer ?? []}
                                                    categoryDropdownList={catalogOverrideDropDownValues?.category ?? []}
                                                    SizeDropDownList={catalogOverrideDropDownValues?.size ?? []}
                                                    TypeDropDownList={catalogOverrideDropDownValues?.type ?? []}
                                                    handleManufacturerChange={onManagedEquipSubFieldChange}
                                                    handleCategoryChange={onManagedEquipSubFieldChange}
                                                    handleSizeChange={onManagedEquipSubFieldChange}
                                                    handleTypeChange={onManagedEquipSubFieldChange}
                                                />
                                            )}

                                            {/* Trailer — 5 fields: manufacturer, style, length, fuelTank, chargingStation */}
                                            {catalogOverrideCriteria?.equipmentType?.label === CONSTANTS.TRAILER && (
                                                <TrailerPresentation
                                                    managedEquipmentValues={catalogOverrideCriteria?.managedEquipFields}
                                                    managedEquipRef={meSubFieldRef}
                                                    manufacturerDropDownList={catalogOverrideDropDownValues?.manufacturer ?? []}
                                                    StyleDropDownList={catalogOverrideDropDownValues?.style ?? []}
                                                    lengthDropDownList={catalogOverrideDropDownValues?.length ?? []}
                                                    fuelTankDropDownList={catalogOverrideDropDownValues?.fuelTank ?? []}
                                                    chargingStationDropdownList={catalogOverrideDropDownValues?.chargingStation ?? []}
                                                    handleManufacturerChange={onManagedEquipSubFieldChange}
                                                    handleStyleChange={onManagedEquipSubFieldChange}
                                                    handleLengthChange={onManagedEquipSubFieldChange}
                                                    handleFuelTankChange={onManagedEquipSubFieldChange}
                                                    handleChargingStationChange={onManagedEquipSubFieldChange}
                                                />
                                            )}

                                            {/* Construction Equipment — 2 fields: category, manufacturer */}
                                            {catalogOverrideCriteria?.equipmentType?.label === CONSTANTS.CONSTRUCTION_EQUIPMENT && (
                                                <DevelopmentPresentation
                                                    managedEquipmentValues={catalogOverrideCriteria?.managedEquipFields}
                                                    managedEquipRef={meSubFieldRef}
                                                    categoryDropdownList={catalogOverrideDropDownValues?.category ?? []}
                                                    manufacturerDropdownList={catalogOverrideDropDownValues?.manufacturer ?? []}
                                                    handleCategoryChange={onManagedEquipSubFieldChange}
                                                    handleManufacturerChange={onManagedEquipSubFieldChange}
                                                />
                                            )}

                                            {/* Standardized Equipment — 2 fields: category, manufacturer */}
                                            {catalogOverrideCriteria?.equipmentType?.label === CONSTANTS.STANDARIZED_EQUIPMENT && (
                                                <StandardizedEquipmentPresentation
                                                    managedEquipmentValues={catalogOverrideCriteria?.managedEquipFields}
                                                    managedEquipRef={meSubFieldRef}
                                                    categoryDropdownList={catalogOverrideDropDownValues?.category ?? []}
                                                    manufacturerDropDownList={catalogOverrideDropDownValues?.manufacturer ?? []}
                                                    handleCategoryChange={onManagedEquipSubFieldChange}
                                                    handleManufacturerChange={onManagedEquipSubFieldChange}
                                                />
                                            )}

                                            {/* Utility Vehicle — 4 fields: seatingCapacity, manufacturer, enclosedCab, capacity */}
                                            {catalogOverrideCriteria?.equipmentType?.label === CONSTANTS.UTILITY_VEHICLE && (
                                                <UtilityVehiclePresentation
                                                    managedEquipmentValues={catalogOverrideCriteria?.managedEquipFields}
                                                    managedEquipRef={meSubFieldRef}
                                                    seatingCapacityDropDownList={catalogOverrideDropDownValues?.seatingCapacity ?? []}
                                                    manufacturerDropDownList={catalogOverrideDropDownValues?.manufacturer ?? []}
                                                    enclosedCabDropDownList={catalogOverrideDropDownValues?.enclosedCab ?? []}
                                                    capacityDropDownList={catalogOverrideDropDownValues?.capacity ?? []}
                                                    handleSeatingCapacityChange={onManagedEquipSubFieldChange}
                                                    handleManufacturerChange={onManagedEquipSubFieldChange}
                                                    handleEnclosedCabChange={onManagedEquipSubFieldChange}
                                                    handleCapacityChange={onManagedEquipSubFieldChange}
                                                />
                                            )}

                                            <Col xs={12} sm={4} md={4} lg={4} className="mb-3 align-self-end">
                                                <PrimaryButton
                                                    text="Search"
                                                    disabled={isCatalogSearchDisabled}
                                                    onClick={() => { SearchedCatalog?.(); setShowCatalogGrid(true); }}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {!isProductionVehicle && !isManagementVehicle && !isManagedEquipment && (
                                    <div className="vehicle-request-form-row">
                                        <div className="vehicle-request-form-col">
                                            <Label>Search</Label>
                                            <InputField disabled value="Catalog override not available for this type" />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {showCatalogGrid && (
                                <div className="vehicle-request-catalog-grid">
                                    <div className="softura-table">
                                        <SofturaTable
                                            className="vehicle-request-catalog-table"
                                            data={catalogGridData}
                                            columns={catalogGridColumns}
                                            sort={false}
                                            pagination={false}
                                            globalSearch={false}
                                            filter={false}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </Col>
                )}
            </Row>
            <div className="cancel-btn-block">
                <OutlineButton
                    text="Cancel"
                    className="cancel-btn me-2"
                    onClick={handleClickCancel}
                    data-attribute="PurchaseDetail_Default_Button_2" />
                <OutlineButton
                    text="Save"
                    className="save-btn me-2"
          onClick={()=>{
            savePurchaseOrder && savePurchaseOrder();}}
                    disabled={purchaseOrderStepperData.loading || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || isCompleted || isRequisitionComplete || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                    data-attribute="PurchaseDetail_Default_Button_3" />
                <CancelConfirmationPopup
                    hideDialog={hideDialog}
                    Popupcontent={Popupcontent}
                    popupOutlinebtnOnclick={popupOutlinebtnOnclick}
                    popupPrimarybtnOnclick={Popupcontent?.popupPrimarybtnOnclick ? Popupcontent?.popupPrimarybtnOnclick : () => popupPrimarybtnOnclick("Home")}
                />
                {catalogOverridePopupcontent && (
                    <PopupDialogbox
                        hideDialog={!catalogOverridePopupcontent?.isDialogVisible}
                        onDismiss={hideCatalogOverrideDialog}
                        Popupcontent={catalogOverridePopupcontent}
                        popupOutlinebtnOnclick={hideCatalogOverrideDialog}
                        popupPrimarybtnOnclick={catalogOverridePopupcontent?.popupPrimarybtnOnclick}
                        commentBoxId="purchase-detail-catalog-override-comment"
                    />
                )}
            </div>
            {showPoolPopup ? (
                <ModalPopup
                    ShowModalPopupFooter={true}
                    ModalPopupTitle="ASSET POOL"
                    ModalPopupType="large"
                    FooterSecondaryBtnTxt="Cancel"
                    FooterPrimaryBtnTxt="Pick"
                    closeModalPopup={togglePopup}
                    PrimaryBtnOnclick={handleClickPick}
                    SecondryBtnOnclick={togglePopup}
                    data-attribute="PurchaseDetail_Default_ModalPopup">
                    <AssetPoolPopup
                        poolGridData={poolGridData}
                        activeRow={activeRow}
                        errorMessage={assetPoolError}
                        setAssetPoolError={setAssetPoolError}
                    />
                </ModalPopup>
            ) : null}

            {showCatalogComparePopup ? (
                <ModalPopup
                    ModalPopupTitle="Catalog"
                    ModalPopupType="large"
                    ModalPopupName="vehicle-catalog-compare-modal"
                    closeModalPopup={() => setShowCatalogComparePopup && setShowCatalogComparePopup(false)}
                >
                    <div className="vehicle-catalog-compare-popup">
                        <div className="compare-item-section">
                            <div className="compare-item-title">Original Approved Item:</div>
                            <div className="compare-item-grid">
                                {isManagedEquipment ? (
                                    <div className="compare-item-field"><div className="field-label">Equipment Type</div><div className="field-value">{itemDetails?.orderRequestSubType ?? '-'}</div></div>
                                ) : (
                                    <>
                                        {isManagementVehicle && <div className="compare-item-field"><div className="field-label">Driver Title</div><div className="field-value">{itemDetails?.driverTitle ?? '-'}</div></div>}
                                        <div className="compare-item-field"><div className="field-label">Vehicle</div><div className="field-value">{itemDetails?.vechileType ?? '-'}</div></div>
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label">Upfit Option</div><div className="field-value">{itemDetails?.upfitOption ?? '-'}</div></div>}
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label">Snow Setup</div><div className="field-value">{itemDetails?.snowSetup ?? '-'}</div></div>}
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label">Capacity</div><div className="field-value">{itemDetails?.vehicleCapacity ?? '-'}</div></div>}
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label"># of Doors</div><div className="field-value">{itemDetails?.noOfDoors ?? '-'}</div></div>}
                                        <div className="compare-item-field"><div className="field-label">Drive Train</div><div className="field-value">{itemDetails?.driveTrain ?? '-'}</div></div>
                                        <div className="compare-item-field"><div className="field-label">Fuel Type</div><div className="field-value">{itemDetails?.fuelType ?? '-'}</div></div>
                                    </>
                                )}
                            </div>
                            <div className="compare-item-price">{getBudgetingPriceDisplay(originalBudgetingPriceValue)}</div>
                        </div>
                        <div className="compare-item-section">
                            <div className="compare-item-title">Newly Selected Item:</div>
                            <div className="compare-item-grid">
                                {isManagedEquipment ? (
                                    <div className="compare-item-field"><div className="field-label">Equipment Type</div><div className="field-value">{catalogItemByAssetModelId?.orderRequestSubType ?? '-'}</div></div>
                                ) : (
                                    <>
                                        {isManagementVehicle && <div className="compare-item-field"><div className="field-label">Driver Title</div><div className="field-value">{catalogOverrideCriteria?.driverTitle?.text ?? '-'}</div></div>}
                                        <div className="compare-item-field"><div className="field-label">Vehicle</div><div className="field-value">{catalogItemByAssetModelId?.vehicleType ?? '-'}</div></div>
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label">Upfit Option</div><div className="field-value">{catalogItemByAssetModelId?.upfitOption ?? '-'}</div></div>}
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label">Snow Setup</div><div className="field-value">{catalogItemByAssetModelId?.snowSetup ?? '-'}</div></div>}
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label">Capacity</div><div className="field-value">{catalogItemByAssetModelId?.truckSize ?? '-'}</div></div>}
                                        {isProductionVehicle && <div className="compare-item-field"><div className="field-label"># of Doors</div><div className="field-value">{catalogItemByAssetModelId?.noOfDoors ?? '-'}</div></div>}
                                        <div className="compare-item-field"><div className="field-label">Drive Train</div><div className="field-value">{catalogItemByAssetModelId?.driveTrain ?? '-'}</div></div>
                                        <div className="compare-item-field"><div className="field-label">Fuel Type</div><div className="field-value">{catalogItemByAssetModelId?.fuelType ?? '-'}</div></div>
                                    </>
                                )}
                            </div>
                            <div className="compare-item-price">{getBudgetingPriceDisplay(newBudgetingPriceValue)}</div>
                        </div>

                        {isPriceThresholdViolationValue && (
                            <div className="text-danger fw-bold mt-2">
                                Price Threshold Violation: The new price exceeds 10% of the originally approved price.
                            </div>
                        )}
                        {isZeroOrInvalidCatalogPrice && (
                            <div className="text-danger fw-bold mt-2">
                                The new price must be greater than 0.
                            </div>
                        )}
                        <div className="compare-popup-actions">
                            <OutlineButton text="Cancel" className="compare-action-btn" onClick={() => setShowCatalogComparePopup && setShowCatalogComparePopup(false)} />
                            <OutlineButton
                                text="Save"
                                className="compare-action-btn"
                                onClick={() => onSaveCatalogOverride && onSaveCatalogOverride()}
                                disabled={isCompareSaveDisabled}
                            />
                        </div>
                    </div>
                </ModalPopup>
            ) : null}
        </>
    );
};

export default PurchaseDetail;
